module.exports = __webpack_public_path__ + "img/logo-full.f5f4877b.svg";